import { render } from "./Checkout.vue?vue&type=template&id=20458cb2"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Cart/Checkout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20458cb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20458cb2', __exports__)) {
    api.reload('20458cb2', __exports__)
  }
  
  module.hot.accept("./Checkout.vue?vue&type=template&id=20458cb2", () => {
    api.rerender('20458cb2', render)
  })

}


export default __exports__